import React from 'react';
import { Flex } from '@highereducation/hen-ui';

/**
 * Shown while dynamic options are loading (e.g. MultiQuestion child questions).
 */
export const OptionsLoadingPlaceholder: React.FC<{ count?: number }> = ({
  count = 6,
}) => (
  <Flex
    wrap='wrap'
    gap='md'
    justify='center'
    align='center'
    className='py-6 w-full'
  >
    {Array.from({ length: count }).map((_, index) => (
      <div
        key={index}
        className='animate-pulse rounded-full bg-gray-300 h-10'
        style={{ width: `${120 + (index % 3) * 40}px` }}
      />
    ))}
  </Flex>
);
